import { Controller } from "@hotwired/stimulus"

// Handles individual field behavior
export default class extends Controller {
  static values = {
    fieldId: String,
    formId: String
  }

  connect() {
    // Field connected
  }

  delete(event) {
    event.preventDefault()
    event.stopPropagation()

    // Renders as Common::Confirmation::Component in the field's own markup
    // (settings/form_definitions/_field.html.erb) — no window.confirm.
    const modal = document.getElementById(`form-field-${this.fieldIdValue}-delete-confirm`)
    if (!modal) return

    modal.addEventListener("confirmation:confirmed", () => this.performDelete(), { once: true })
    modal.showModal()
    document.body.style.overflow = "hidden"
  }

  performDelete() {
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
    const url = `/forms/${this.formIdValue}/fields/${this.fieldIdValue}`

    fetch(url, {
      method: "DELETE",
      headers: {
        "X-CSRF-Token": csrfToken,
        "Accept": "text/vnd.turbo-stream.html"
      }
    })
    .then(response => response.text())
    .then(html => {
      Turbo.renderStreamMessage(html)
    })
    .catch(error => console.error("Error deleting field:", error))
  }
}
